<template>
    <BreadCrumb PageTitle="Les devoirs corrigés" />
    <CorrectionSession />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import CorrectionSession from "@/components/Composition/CorrectionSession.vue";
  
    export default defineComponent({
      name: "CorrectionSessionPage",
      components: {
        BreadCrumb,
        CorrectionSession,
      },
    });
  </script>